/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ContactInfo/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Email from './Email/index'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import Phone from './Phone/index'
import Postal from './Postal/index'
import React from 'react'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'
import TysiaCardHeader from 'DesignSystem/TysiaCard/TysiaCardHeader/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import Tysiav2Contact from 'DesignSystem/Svgs/Tysiav2Contact/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ContactInfo({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo"
  
}) {
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 size="xlarge"
 flexGrow={1}
 flexShrink={1}
 flexBasis="100%"
 borderColor={dtColorsNeutral300}
>
{childProps => (
<React.Fragment>
<TysiaCardHeader
{...childProps}
  viewPath={`${viewPath}/TysiaCardHeader`}
 paddingTop={dtSpaceLs}
 paddingBottom={dtSpaceLs}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
 borderBottomColor={dtColorsNeutral200}
 borderBottomWidth={1}
>
{childProps => (
<div
  data-testid="ContactInfo.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-21nK64': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2Contact
  viewPath={`${viewPath}/Tysiav2Contact`}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 text="Contact information"
/>
</div>
)}
</TysiaCardHeader>
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 paddingTop={dtSpaceXs}
 paddingBottom={dtSpaceLs}
 paddingLeft={0}
 paddingRight={0}
 flexDirection="column"
 overflowX="visible"
 overflowY="visible"
>
{childProps => (
<React.Fragment>
<Postal
{...childProps}
  viewPath={`${viewPath}/Postal`}
/>
<HorizontalDivider
{...childProps}
  viewPath={`${viewPath}/HorizontalDivider`}
 marginTop={dtSpaceLs}
 marginBottom={dtSpaceXxs}
/>
<Phone
{...childProps}
  viewPath={`${viewPath}/Phone`}
/>
<HorizontalDivider
{...childProps}
  viewPath={`${viewPath}/HorizontalDivider`}
 marginTop={dtSpaceLs}
 marginBottom={dtSpaceXxs}
/>
<Email
{...childProps}
  viewPath={`${viewPath}/Email`}
/>
</React.Fragment>
)}
</TysiaCardContent>
</React.Fragment>
)}
</TysiaCard>
{children}
</React.Fragment>)
}